import React from 'react';

import styles from './index.module.css';

interface Props {
  zIndex?: number;
  children: React.ReactNode;
}

const Overlay: React.FC<Props> = ({children, zIndex}) => {
  return (
    <div className={styles.container} style={{zIndex}}>
      {children}
    </div>
  );
};

export default Overlay;
